// 使用运行时版本 Vue（Element-UI 需要运行时版本才能正常显示 el-table）
// 注意：通过 Webpack 别名配置（vue.config.js），import Vue from 'vue' 会自动映射到 vue.runtime.esm.js
// builtInMethods.js 中会使用完整版 Vue (vue/dist/vue.esm.js) 进行动态模板编译
import Vue from 'vue'; // 通过 Webpack 别名映射到 vue.runtime.esm.js
import App from './App';
import Modal from './components/modal';
import router from './router';
import store from './store/router'; // 导入 Vuex store
import Vant from 'vant';
import axios from 'axios';
import echarts from 'echarts';
import { Message } from 'element-ui';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { formatTime } from '@/utils/time';
import { EventBus } from '@/utils/eventBus.js';

import 'vant/lib/index.css';
import './assets/css/style.css';
import './assets/css/yammy_font.css';
import './assets/css/font-icon/iconfont.css';
import './assets/css/workbench.css';
import directive from './directive'; // v-click-outside

Vue.use(directive);
Vue.use(ElementUI);
Vue.use(Vant);

Vue.component('gzt-modal', Modal);

Vue.config.productionTip = false;

Vue.config.devtools = true;

Vue.prototype.$echarts = echarts;

// 使用标准的 VUE_APP_ 前缀环境变量，如果不存在则使用默认值
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

Vue.prototype.$baseURL = process.env.VUE_APP_BASE_URL;

Vue.prototype.$imageURL = process.env.VUE_APP_BASE_IMG_URL;

Vue.prototype.$versionNUM = '25.12.3'; // 版本号

axios.interceptors.request.use(
  (config) => {
    // 判断是否存在token，如果存在的话，则每个http header都加上token
    if (window.localStorage.getItem('gzt_uid')) {
      config.headers.token = window.localStorage.getItem('gzt_uid');
    }
    if (window.localStorage.getItem('gzt_tenantId')) {
      config.headers.tenantId = window.localStorage.getItem('gzt_tenantId');
    }
    config.headers.ApplicationId = 1;
    return config;
  },
  (error) => {
    return Promise.reject(error.response);
  }
);

// 相应拦截器
axios.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    if(response.data.code == 0 || response.data.code == 200){
      return response;
    }else {
      Message.error(response.data.msg);
    }
  },
  error => {
    if (error.response) {
      // 请求已发出但服务器响应的状态码不在 2xx 范围内
      Message.error(error.response.data.msg);
    } else if (error.request) {
      // 请求已发出，但没有收到响应
      console.error('No response received:', error.request);
    } else {
      // 一些设置请求时发生错误
      console.error('Error setting up request:', error.message);
    }
    return Promise.reject(error);
  }
);


Vue.prototype.$axios = axios;

// 获取参数
Vue.prototype.$geturlparam = function (name) {
  const url = window.location.search; // 获取url中"?"符后的字串
  const theRequest = new Object();
  if (url.indexOf('?') != -1) {
    const str = url.substr(1);
    const strs = str.split('&');
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = decodeURI(strs[i].split('=')[1]);
    }
  }
  return theRequest[name];
};

// 判断是否超出当前时间
Vue.prototype.$isTimeEnd = function (targetTime) {
  const currentTime = new Date().getTime();
  return (new Date(targetTime)).getTime() <= currentTime;
};

Vue.prototype.$formatTime = function (time) {
  return formatTime(time);
};

// 暴露EventBus和Vue到全局，供代码编辑器等组件使用
if (typeof window !== 'undefined') {
  window.EventBus = EventBus;
  window.Vue = Vue; // 暴露Vue，供代码编辑器创建动态组件使用（包含所有原型方法）
  window.ElementUI = ElementUI; // 暴露ElementUI，供代码编辑器使用
  window.echarts = echarts; // 暴露echarts，供代码编辑器使用
  window.axios = axios; // 暴露axios，供代码编辑器使用
  // 注意：所有 Vue.prototype.$xxx 方法会自动继承到动态创建的组件中
  // 包括：$axios, $echarts, $baseURL, $imageURL, $formatTime, $getDate, 
  // $geturlparam, $isTimeEnd, $message, $confirm, $alert, $prompt, $loading, $notify 等
  // 打包后这些方法仍然可用，因为它们是运行时绑定的原型方法
}

// 获取当前时间
Vue.prototype.$getDate = function (formats) {
  const zero = function (value) {
    if (value < 10) {
      return `0${value}`;
    }
    return value;
  };
  const now = new Date();
  const year = now.getFullYear();
  const month = zero(now.getMonth() + 1);
  const day = zero(now.getDate());
  const hour = zero(now.getHours());
  const minute = zero(now.getMinutes());
  const second = zero(now.getSeconds());
  // console.log(111, year, month, day, hour, minute);
  return formats.replace(/Y|m|d|H|i|s/ig, (matches) => {
    return ({
      Y: year,
      m: month,
      d: day,
      H: hour,
      i: minute,
      s: second,
    })[matches];
  });
};

new Vue({
  router,
  store,
  directives: {
    clickOutside: directive
  },
  render: h => h(App),
}).$mount('#app')
